export * from "./AtomicModels";
export * from "./PropertiesMatter";
export * from "./ChemicalBonds";
export * from "./IonicCompounds";
export * from "./CovalentCompounds";
export * from "./MixSeparation";
export * from "./PeriodicProperties";

export const structureMatterItems = {
  "Modelos atómicos": {
    path: "/quimica/estructura-materia/modelos-atomicos",
    subtopics: {
      "Leucipo y demócrito": {
        path: "/quimica/estructura-materia/modelos-atomicos",
        scrollToId: "leucipoDemocrito",
      },
      Dalton: {
        path: "/quimica/estructura-materia/modelos-atomicos",
        scrollToId: "dalton",
      },
      Thomson: {
        path: "/quimica/estructura-materia/modelos-atomicos",
        scrollToId: "thomson",
      },
      Rutherford: {
        path: "/quimica/estructura-materia/modelos-atomicos",
        scrollToId: "rutherford",
      },
      Bohr: {
        path: "/quimica/estructura-materia/modelos-atomicos",
        scrollToId: "bohr",
      },
      Sommerfeld: {
        path: "/quimica/estructura-materia/modelos-atomicos",
        scrollToId: "sommerfeld",
      },
      Schrödinger: {
        path: "/quimica/estructura-materia/modelos-atomicos",
        scrollToId: "schrodinger",
      },
    },
  },
  "Propiedades de la materia": {
    path: "/quimica/estructura-materia/propiedades-materia",
  },
  "Separación de mezclas": {
    path: "/quimica/estructura-materia/separacion-mezclas",
  },
  "Enlaces químicos": {
    path: "/quimica/estructura-materia/enlaces-quimicos",
    subtopics: {
      "Enlace iónico": {
        path: "/quimica/estructura-materia/enlaces-quimicos",
        scrollToId: "enlaceIonico",
      },
      "Enlace covalente": {
        path: "/quimica/estructura-materia/enlaces-quimicos",
        scrollToId: "enlaceCovalente",
      },
      "Enlace metálico": {
        path: "/quimica/estructura-materia/enlaces-quimicos",
        scrollToId: "enlaceMetalico",
      },
    },
  },
  "Compuestos iónicos": {
    path: "/quimica/estructura-materia/compuestos-ionicos",
  },
  "Compuestos covalentes": {
    path: "/quimica/estructura-materia/compuestos-covalentes",
  },
  "Propiedades periódicas": {
    path: "/quimica/estructura-materia/propiedades-periodicas",
    subtopics: {
      "Radio atómico": {
        path: "/quimica/estructura-materia/propiedades-periodicas",
        scrollToId: "radioAtomico",
      },
      "Afinidad electrónica": {
        path: "/quimica/estructura-materia/propiedades-periodicas",
        scrollToId: "afinidadElectronica",
      },
      "Energía de ionización": {
        path: "/quimica/estructura-materia/propiedades-periodicas",
        scrollToId: "energiaIonizacion",
      },
      Electronegatividad: {
        path: "/quimica/estructura-materia/propiedades-periodicas",
        scrollToId: "electronegatividad",
      },
    },
  },
};
